

































































import { Component, Vue } from 'vue-property-decorator';
import {
  CompilationFullDTO,
  GetClientsRequestClientTypeEnum,
} from '@/api';
import services from '@/services';
import { clientsModule } from '@/store';
import BaseLayout from '@/layouts/BaseLayout.vue';
import { differenceInSeconds } from 'date-fns';

@Component({
  name: 'compilations-page',
  components: {
    BaseLayout,
  },
})
export default class Clients extends Vue {
  loading = false;

  total: number | null = null;

  compilations: CompilationFullDTO[] = [];

  currentDate = new Date();

  intervalId: undefined | number = undefined;

  statusList = {
    NEW: 'Новый',
    IN_PROGRESS: 'В работе',
    FINISHED: 'Готово',
  };

  // params: GetClientsRequest = {
  //   offset: 0,
  //   length: 50,
  //   clientType: GetClientsRequestClientTypeEnum.CONCIERGE,
  // };

  // beforeRouteUpdate(to: Route, from: Route, next: () => void) {
  //   this.setParams(to);
  //   this.fetchUsers();
  //   next();
  // }

  async created() {
    // this.setParams(this.$route);
    clientsModule.fetchStylists();
    services
      .clientsService()
      .clientEndpointStatusList()
      .then(r => r.data);
    this.fetchCompilations();
  }


  mounted() {
    this.intervalId = setInterval(() => {
      this.currentDate = new Date();
    }, 60000);
  }

  beforeDestroy() {
    clearInterval(this.intervalId);
  }

  get stylists() {
    return clientsModule.stylists;
  }

  get stylistId() {
    return this.$route.query.STYLIST ? this.$route.query.STYLIST : 'all';
  }

  // setParams(to: Route) {
  //   this.params = {
  //     ...this.params,
  //     offset: 0,
  //     sortBy: to.query.sortBy
  //       ? (to.query.sortBy as GetClientsRequestSortByEnum)
  //       : GetClientsRequestSortByEnum.CREATED_AT,
  //     sortOrder: to.query.sortOrder
  //       ? (to.query.sortOrder as GetClientsRequestSortOrderEnum)
  //       : GetClientsRequestSortOrderEnum.ASC,
  //     clientType: (to.query.type as GetClientsRequestClientTypeEnum) || this.params.clientType,
  //   };
  // }

  // @Watch('searchString')
  // async onSearchChange(value: string) {
  //   this.debouncedSearch(value);
  // }

  async fetchCompilations() {
    this.loading = true;
    try {
      const { data } = await services
        .compilationsApi()
        .compilationEndpointOrders(undefined, undefined, Number(this.$route.params.clientId));
      // this.compilations = (this.params.offset || 0) > 0
      //   ? this.compilations.concat(data.clients || [])
      //   : data.clients || [];
      this.compilations = data;
      this.total = data.length || null;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      this.loading = false;
    }
  }

  selectStylist(id: string | 'all') {
    if (id !== 'all') {
      this.$router.push({
        query: { ...this.$route.query, STYLIST: String(id) },
      });
    } else {
      this.$router.push({
        query: { ...this.$route.query, STYLIST: undefined },
      });
    }
  }

  selectClientType(type: GetClientsRequestClientTypeEnum) {
    this.$router.push({
      query: { ...this.$route.query, type },
    });
  }

  formatDuration(start: number | Date, finish: number | Date) {
    const diffTime = differenceInSeconds(finish, start);
    if (!diffTime) return '00:00'; // divide by 0 protection
    const minutes = Math.abs(Math.floor(diffTime / 60) % 60).toString();
    const hours = Math.abs(Math.floor(diffTime / 60 / 60)).toString();
    return `${diffTime < 0 ? '-' : ''}${hours.length < 2 ? 0 + hours : hours}ч ${minutes.length < 2 ? 0 + minutes : minutes}м`;
  }

  getInfo(compilation: CompilationFullDTO) {
    if (compilation?.info) {
      try {
        return JSON.parse(compilation?.info as string);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return null;
      }
    }
    return null;
  }

  getInfoFiledValue(compilation: CompilationFullDTO, id: number) {
    const info = this.getInfo(compilation);
    return info?.data.find((f: {id: number}) => f.id === id)?.value as string | undefined;
  }

  getServiceTitle(compilation: CompilationFullDTO) {
    const title = this.getInfoFiledValue(compilation, 42);
    switch (title) {
      case 'Новый образ':
        return 'Образ из 5 вещей';
      case 'Новая капсула':
        return 'Капсула из 12 вещей';
      case 'Освежить гардероб':
        return 'Обновление гардероба';
      default:
        return title;
    }
  }
}
